import React from "react";

// reactstrap components
import {
    Alert,
    Card,
    CardHeader,
    CardBody,
    Col,
    Row,
    Table,
    Modal,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import ShoppingDataService from "../../services/ShoppingDataService";
import WarehouseDataService from "../../services/WarehouseDataService";

const formatDate = (value) => {
    if (!value) return "-";
    return new Date(value).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

const STATUS_LABEL = {
    create: "Terbuka",
    proceed: "Selesai",
};

const StatusBadge = ({ status }) => (
    <span className={`badge badge-pill ${status === "proceed" ? "bg-gradient-success" : "bg-gradient-warning"} text-white`}>
        {STATUS_LABEL[status] || status || "-"}
    </span>
);

const COLUMN_WIDTHS = ['34%', '20%', '10%', '18%', '18%'];

const ColGroup = () => (
    <colgroup>
        {COLUMN_WIDTHS.map((width, i) => (
            <col key={i} style={{ width }} />
        ))}
    </colgroup>
);

class ShoppingDetailModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            productList: [],
        };
        this.ShoppingDataService = new ShoppingDataService();
        this.WarehouseDataService = new WarehouseDataService();
    }

    onModalOpened() {
        this.fetchProductList();
    }

    onModalClosed() {
        this.setState({
            productList: [],
            status: undefined,
            warehouseName: undefined,
            errorMessage: undefined,
        })
    }

    fetchProductList() {
        this.ShoppingDataService.getShoppingProductList(this.props.currentShopping.Id, 1, 100)
            .then((res) => {
                this.setState(res);

                const warehouseId = res.warehouseId || this.props.currentShopping.WarehouseId;
                if (warehouseId && !res.needRelogin) {
                    this.fetchWarehouse(warehouseId);
                }
            })
    }

    fetchWarehouse(warehouseId) {
        this.WarehouseDataService.getDetail(warehouseId)
            .then((res) => {
                if (res.warehouseName) {
                    this.setState({ warehouseName: res.warehouseName });
                }
            })
    }

    getSubtotal() {
        return (this.state.productList || []).reduce((sum, item) => sum + (item.TotalPrice || 0), 0);
    }

    render() {
        const productList = this.state.productList || [];

        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.props.formModal}
                toggle={this.props.toggleModal}
                onOpened={this.onModalOpened.bind(this)}
                onClosed={this.onModalClosed.bind(this)}
            >
                <div className="modal-body p-0">
                    <Card className="shadow border-0 mb-0">
                        <CardHeader className="bg-gradient-info border-0">
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <h6 className="text-uppercase text-white ls-1 mb-1 opacity-8">
                                        Tanggal Belanja
                                    </h6>
                                    <h2 className="text-white mb-2">
                                        <i className="ni ni-cart mr-2" />
                                        {formatDate(this.state.shoppingDate || this.props.currentShopping.ShoppingDate)}
                                    </h2>
                                    <StatusBadge status={this.state.status || this.props.currentShopping.Status} />
                                </div>
                                <button
                                    aria-label="Close"
                                    className="close text-white"
                                    type="button"
                                    onClick={this.props.toggleModal}
                                >
                                    <span aria-hidden={true}>&times;</span>
                                </button>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-4">
                            {this.state.errorMessage && (
                                <Alert color="danger">
                                    {this.state.errorMessage}
                                </Alert>
                            )}

                            <Row className="mb-4">
                                <Col xs="4">
                                    <div className="text-muted text-sm text-uppercase ls-1">Pembeli</div>
                                    <div className="h4 mb-0">{this.props.currentShopping.CreatorName || '-'}</div>
                                </Col>
                                <Col xs="4">
                                    <div className="text-muted text-sm text-uppercase ls-1">Warehouse</div>
                                    <div className="h4 mb-0">{this.state.warehouseName || '-'}</div>
                                </Col>
                                <Col xs="4" className="text-right">
                                    <div className="text-muted text-sm text-uppercase ls-1">Jumlah Produk</div>
                                    <div className="h4 mb-0">{productList.length} item</div>
                                </Col>
                            </Row>

                            <h6 className="text-uppercase text-muted ls-1 mb-3">Daftar Produk</h6>

                            <div className="border rounded" style={{ overflow: 'hidden' }}>
                                <Table className="align-items-center table-flush mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <ColGroup />
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">Nama produk</th>
                                            <th scope="col">Barcode</th>
                                            <th scope="col">Qty</th>
                                            <th scope="col">Harga beli</th>
                                            <th scope="col">Total</th>
                                        </tr>
                                    </thead>
                                </Table>
                                <div style={{ maxHeight: '280px', overflowY: 'auto' }}>
                                    <Table className="align-items-center table-flush mb-0" style={{ tableLayout: 'fixed', width: '100%' }}>
                                        <ColGroup />
                                        <tbody>
                                            {productList.length === 0 && (
                                                <tr>
                                                    <td colSpan={5} className="text-center text-muted py-4">
                                                        Tidak ada produk.
                                                    </td>
                                                </tr>
                                            )}
                                            {productList.map((item) => (
                                                <tr key={item.Id}>
                                                    <th scope="row" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                        {item.ProductName}
                                                    </th>
                                                    <td className="text-muted" style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                        {item.ProductBarcode}
                                                    </td>
                                                    <td>
                                                        <span className="badge badge-pill bg-gradient-default text-white">
                                                            {item.Quantity}
                                                        </span>
                                                    </td>
                                                    <td className="text-muted">
                                                        <NumberFormat
                                                            value={item.Price}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            prefix={'Rp.'} suffix={',00'} />
                                                    </td>
                                                    <td className="font-weight-bold">
                                                        <NumberFormat
                                                            value={item.TotalPrice}
                                                            displayType={'text'}
                                                            thousandSeparator={true}
                                                            prefix={'Rp.'} suffix={',00'} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="bg-gradient-secondary border-top px-4 py-3 d-flex justify-content-between align-items-center">
                                    <span className="text-uppercase text-sm font-weight-bold text-muted ls-1">Subtotal</span>
                                    <span className="h3 mb-0 text-primary">
                                        <NumberFormat
                                            value={this.getSubtotal()}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'Rp.'} suffix={',00'} />
                                    </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }
}

export default ShoppingDetailModal;
